import React from "react"
import { t, fmtHours, fmtMoney, fmtNumber } from "../helpers/format"

const Card = ({ label, value, sub, tone, subTone, progress }) => (
  <div className="flex flex-col gap-1.5 px-4 py-3 bg-white border border-slate-200 rounded-xl">
    <div className="text-[10.5px] uppercase tracking-wider text-slate-500 font-medium">{label}</div>
    <div className={`text-[18px] font-semibold tabular-nums ${tone || "text-slate-900"}`}>{value}</div>
    {progress != null && (
      <div className="h-[4px] rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full rounded-full bg-brand-500 transition-all duration-500" style={{ width: `${Math.min(100, progress)}%` }} />
      </div>
    )}
    {sub && <div className={`text-[11.5px] mt-auto ${subTone || "text-slate-500"}`}>{sub}</div>}
  </div>
)

const KpiStrip = ({ kpis }) => {
  const k = kpis || {}
  const progress = k.planned > 0 ? (k.hours / k.planned) * 100 : null
  return (
    <div className="px-7 pb-4">
      <div className="grid gap-3 grid-cols-2 md:grid-cols-4 xl:grid-cols-8">
        <Card
          label    = {t("kpis.hours")}
          value    = {fmtHours(k.hours)}
          progress = {progress}
          sub      = {t("kpis.planned", { hours: fmtHours(k.planned) })}
        />
        <Card
          label   = {t("kpis.to_review")}
          value   = {fmtNumber(k.to_review)}
          tone    = {k.to_review > 0 ? "text-emerald-700" : null}
          sub     = {t("kpis.to_review_hint")}
        />
        <Card
          label   = {t("kpis.approved")}
          value   = {fmtNumber(k.approved)}
          sub     = {t("kpis.approved_hint")}
        />
        <Card
          label   = {t("kpis.unsigned")}
          value   = {fmtNumber(k.unsigned)}
          tone    = {k.unsigned > 0 ? "text-blue-700" : null}
          sub     = {t("kpis.unsigned_hint")}
        />
        <Card
          label   = {t("kpis.overtime")}
          value   = {fmtHours(k.overtime)}
          tone    = {k.overtime > 0 ? "text-amber-600" : null}
          sub     = {k.over_max > 0 ? t("kpis.over_max", { count: k.over_max }) : t("kpis.overtime_hint")}
          subTone = {k.over_max > 0 ? "text-rose-600" : null}
        />
        <Card
          label   = {t("kpis.meals")}
          value   = {fmtNumber(k.meals)}
          sub     = {t("kpis.meals_hint")}
        />
        <Card
          label   = {t("kpis.geofence")}
          value   = {fmtNumber(k.geofence)}
          tone    = {k.geofence > 0 ? "text-amber-600" : null}
          sub     = {t("kpis.geofence_hint")}
        />
        <Card
          label   = {t("kpis.labor_cost")}
          value   = {fmtMoney(k.labor_cost)}
          sub     = {t("kpis.labor_cost_hint")}
        />
      </div>
    </div>
  )
}

export default KpiStrip
